import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Tooltip,
} from "@mui/material";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import { useState } from "react";
import DragProductMasterFile from "./utils/DragProductMasterFile";

const ImportButton = ({ channelKeys, handleSentData }) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Tooltip title="Importar" placement="bottom" arrow>
        <span>
          <Button
            onClick={handleOpen}
            variant="contained"
            sx={{
              backgroundColor: "#354887",
              "&:hover": {
                backgroundColor: "#354887",
              },
              height: "45px",
              width: "20.5px",
              textTransform: "uppercase",
              padding: 0,
            }}
          >
            <FileUploadOutlinedIcon
              sx={{
                width: 30,
                height: 30,
              }}
            />
          </Button>
        </span>
      </Tooltip>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Importar Productos Maestros
        </DialogTitle>
        <DialogContent>
          <DragProductMasterFile
            channelKeys={channelKeys}
            setLoading={setLoading}
            disabled={loading}
            handleClose={handleClose}
            loading={loading}
            handleSentData={handleSentData}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} disabled={loading}>
            Cancelar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ImportButton;
